import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css']
})
export class VerificationComponent implements OnInit {

  form: any | FormGroup
  modelSubtitle = false

  checked = false
  name = ""
  version = ""
  isActive = false
  data: any =[];
  prospectdata: any = [];
  prospectid: any = "";
  cid:any

    first: number = 0;
  isLoading: any = false
  tableSize: number = 10;

  pageNumber: number = 0;
  pageNumber1: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;

    actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }
  searchFilter: string = "";

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllProspectRegistrationWithPagination(this.pageNumber,this.recordsPerPage)
    this.form = this.fb.group({
      date: [''],
    })  
  let href:any = window.location.href;
  let messages = href.split('/') 
let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
  this.actionControls = action
  }

  verification(){
    let body = 
    // {
    //   "applicationId": Number(id),
    //   "userId": String(sessionStorage.getItem("userId")),
    //   "date": new Date().getTime()
    // }

    {
      "note": "",
      "status": "VERIFIED",
      "updatedDate": new Date().getTime()
    }

    console.log(body)
    this.generic_service.addVerification(this.prospectid,body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllProspectRegistrationWithPagination(this.pageNumber,this.recordsPerPage)
        this.toastr.success("Successfully Verified");
        this.cancelModel()

      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);

      },
    )
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.pageNumber1 = event.page;

    if(this.searchFilter != ""){
      this.getAllProspectRegistrationWildSearchWithPagination(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllProspectRegistrationWithPagination(this.pageNumber,this.recordsPerPage)
    }
  }

  refreshAll(){
    this.pageNumber = 0
    this.first = 0
    this.searchFilter = ""
    this.getAllProspectRegistrationWithPagination(this.pageNumber,this.recordsPerPage)

  }

  getAllProspectRegistrationWildSearchWithPagination(pageNumber: any,recordsPerPage: any){
   if(this.searchFilter == "" || this.searchFilter == null){
      return
    }

    this.isLoading = true

    this.generic_service.getAllProspectRegistrationWildSearchWithPagination(this.searchFilter,pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        for(let list of response.response.prospectRegistrationList){
          let applicationFormFor: any = ""
          let fatherHusbandName: any = ""
          let noOfCableConnection: any = ""
          let noOfInternetConnection: any = ""
          let identityProofType: any = ""
          let termsOfPayment: any = ""
          let bookedBy: any = ""
          let agentName: any = ""
          let identityProofAttachmentURL: any = ""
          let customerId: any = ""

          if(list.keyValuePairs != null){
            for(let key of list.keyValuePairs){
              if(key.key == "Application Form For"){
                applicationFormFor = key.value
              }

              if(key.key == "Father/Husband Name"){
                fatherHusbandName = key.value
              }

              if(key.key == "No Of Cable Connection"){
                noOfCableConnection = key.value
              }

              if(key.key == "No Of Internet Connection"){
                noOfInternetConnection = key.value
              }

              if(key.key == "Identity Proof Type"){
                identityProofType = key.value
              }

              if(key.key == "Terms Of Payment"){
                termsOfPayment = key.value
              }

              if(key.key == "Booked By"){
                bookedBy = key.value
              }

              if(key.key == "Agent Name"){
                agentName = key.value
              }

              if(key.key == "Identity Proof AttachmentURL"){
                identityProofAttachmentURL = key.value
              }

              if(key.key == "customerId"){
                customerId = key.value
              }
            }
          }

          list.applicationFormFor = applicationFormFor
          list.fatherHusbandName = fatherHusbandName
          list.noOfCableConnection = noOfCableConnection
          list.noOfInternetConnection = noOfInternetConnection
          list.identityProofType = identityProofType
          list.termsOfPayment = termsOfPayment
          list.bookedBy = bookedBy
          list.agentName = agentName
          list.identityProofAttachmentURL = identityProofAttachmentURL
          list.customerId = customerId
        }
        this.data = response.response.prospectRegistrationList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
        this.isLoading = false

      }
    )



  }




  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  // getAllProspect(){
  //   this.generic_service.getAllProspect().subscribe(
  //     (response:any)=>{
  //       this.data = response.response;
  //       console.log(response)
  //     }
  //   )
  // }

  getAllProspectRegistrationWithPagination(pageNumber: any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getAllProspectRegistrationWithPagination(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        for(let list of response.response.prospectRegistrationList){
          let applicationFormFor: any = ""
          let fatherHusbandName: any = ""
          let noOfCableConnection: any = ""
          let noOfInternetConnection: any = ""
          let identityProofType: any = ""
          let termsOfPayment: any = ""
          let bookedBy: any = ""
          let agentName: any = ""
          let identityProofAttachmentURL: any = ""
          let customerId: any = ""

          if(list.keyValuePairs != null){
            for(let key of list.keyValuePairs){
              if(key.key == "Application Form For"){
                applicationFormFor = key.value
              }

              if(key.key == "Father/Husband Name"){
                fatherHusbandName = key.value
              }

              if(key.key == "No Of Cable Connection"){
                noOfCableConnection = key.value
              }

              if(key.key == "No Of Internet Connection"){
                noOfInternetConnection = key.value
              }

              if(key.key == "Identity Proof Type"){
                identityProofType = key.value
              }

              if(key.key == "Terms Of Payment"){
                termsOfPayment = key.value
              }

              if(key.key == "Booked By"){
                bookedBy = key.value
              }

              if(key.key == "Agent Name"){
                agentName = key.value
              }

              if(key.key == "Identity Proof AttachmentURL"){
                identityProofAttachmentURL = key.value
              }

              if(key.key == "customerId"){
                customerId = key.value
              }
            }
          }

          list.applicationFormFor = applicationFormFor
          list.fatherHusbandName = fatherHusbandName
          list.noOfCableConnection = noOfCableConnection
          list.noOfInternetConnection = noOfInternetConnection
          list.identityProofType = identityProofType
          list.termsOfPayment = termsOfPayment
          list.bookedBy = bookedBy
          list.agentName = agentName
          list.identityProofAttachmentURL = identityProofAttachmentURL
          list.customerId = customerId
        }
        this.data = response.response.prospectRegistrationList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
        this.isLoading = false

      }
    )
  }

  getProspectByID(id:any){
    this.prospectid = id
    this.generic_service.getProspectByID(id).subscribe(
      (res:any)=>{
        this.prospectdata = [];
        console.log(res);
        this.prospectdata.push(res.response);
      }
    )
  }

  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.isActive = false
    
  }

  addCustomerInfo(){
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "name": "",
      "address": "",
      "geoAddress": {
        "latitude": "",
        "longitude": ""
      },
      "mobileNo1": "",
      "mobileNo2": "",
      "emailId": "",
      "customerParamEntityList": [
        {
          "key": "",
          "value": ""
        }
      ],
      "status": [
        {
          "customerRegistrationStatus": "APPROVED",
          "updatedDate": 0
        }
      ],
      "latestStatus": "APPROVED",
      "image": "",
      "documents": [],
      "cid": 0
    }
    
  }

}